import api from '@http/api';


export interface IRequestCreatePessoa {
  pessoa?: {
    nome: string;
    cpfcnpj: string;
    email: string;
    telefone: string;
    data_nascimento: any;
    indicador: string;
    leu_comunicado_privacidade: boolean;
    concede_compartilhamento_dados: boolean;
  };
  endereco?: {
    descricao: string;
    numero: string;
    complemento: string;
    bairro: string;
    cidade: string;
    cep: string;
    uf: string;
  };
  entidade: {
    nome: string;
  };
  campanha:{
    descricao: string;
  };
}


export interface IRequestCreatePessoaCrianca {
  nome: string;
  cpfcnpj: string;
  data_nascimento: any;
  entidade: string;
  id_pessoa_responsavel: number;
}

export interface IRequestCreatePessoaTeste {
  pessoa?: {
    nome: string;
    cpfcnpj: string;
    email: string;
    telefone: string;
    data_nascimento: any;
  };
}



class PageCadastroPessoaServices {

  public async CreatePessoa(pessoa: IRequestCreatePessoa) {
    return await api
      .post('api/site/CriarCadastroSemCobranca', pessoa)
      .then(response => {

        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async CreatePessoaCrianca(pessoa: IRequestCreatePessoaCrianca) {
    return await api
      .post('api/site/CriarPessoaSimples', pessoa)
      .then(response => {

        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }



}


export default PageCadastroPessoaServices;
